import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-task-add',
  templateUrl: './task-add.component.html',
  styleUrls: ['./task-add.component.css']
})
export class TaskAddComponent implements OnInit {
  selectedFile: File;
  orgId:any;
  userData:any;
  @ViewChild('selectFile') selectFile: ElementRef;
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {

    let userDataObj = localStorage.getItem('userData');
    if (userDataObj) {
      try {
        this.userData = JSON.parse(userDataObj);
      if(this.userData.attributes.role === "admin"){
        this.orgId= this.userData.id;
      }
      else{
        this.orgId= this.userData.orgId;
      }
      } catch (error) {}
    }
  }

  uploadDocuments() {
    debugger
    this.selectFile.nativeElement.click();
  }
  onFileUpload(event: any) {
    debugger
    this.selectedFile = event.target.files[0];
    if (this.selectedFile) {
      this.uploadDocs();
    } else {
      Swal.fire({
        icon: "error",
        title: "Unsupported File Type. Only xls/xlsx/csv is allowed!",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }
  uploadDocs() {
  
    if (this.selectedFile) {
      const formData: FormData = new FormData();
      formData.append('file', this.selectedFile);
      this.commonService
        .postRequestForFile(`traccartasks/uploadTaks?orgId=${this.orgId}`, formData)
        .then((resp: any) => {
          if (resp?.status) {
            Swal.fire({
              icon: "success",
              title: `Task data added successfully`,
              showConfirmButton: false,
              timer: 1500,
            });
            this.commonService.commonModel.next(false);
          }
        }, (error:any) => {
          console.log('error=>',error)
            Swal.fire({
              // position: 'top-end',
              icon: 'error',
              text: error.data.statusText,
              showConfirmButton: false,
              // toast: true,
              timer: 1500,
            });
          
          // Swal.fire({
          //   icon: "error",
          //   title: "Something Went Wrong!",
          //   showConfirmButton: false,
          //   timer: 1500,
          // });
         
          this.commonService.commonModel.next(false);
        });
    }
    // if (this.selectedFile) {
    //   const formData: FormData = new FormData();
    //   formData.append('file', this.selectedFile);
    //   this.commonService
    //     .postRequestForFile('traccartasks/uploadTaks', formData)
    //     .then((resp: any) => {
    //       if (resp?.status) {
    //         Swal.fire({
    //           icon: "success",
    //           title: `Task data added successfully`,
    //           showConfirmButton: false,
    //           timer: 1500,
    //         });
    //         this.commonService.commonModel.next(false);
    //       }
    //     }, (error:any) => {
    //       console.log('error=>',error)
    //         Swal.fire({
    //           // position: 'top-end',
    //           icon: 'error',
    //           text: error.data.statusText,
    //           showConfirmButton: false,
    //           // toast: true,
    //           timer: 1500,
    //         });
          
    //       // Swal.fire({
    //       //   icon: "error",
    //       //   title: "Something Went Wrong!",
    //       //   showConfirmButton: false,
    //       //   timer: 1500,
    //       // });
         
    //       this.commonService.commonModel.next(false);
    //     });
    // }
  }
}
